import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getInitialValues } from '../utils.ts';
import { validationSchema } from '../validationSchema.ts';
import { TTaxResidencyAdditionalInformation } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/types.ts';
import { selectTaxResidencyAdditionalInformation } from '~/store/identification-form/selectors.ts';
import { useBeneficiaryOwners } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/hooks/useBeneficiaryOwners.ts';

export const useTaxResidencyAdditionalInformationForm = () => {
  const { beneficiaryOwners } = useBeneficiaryOwners();

  const formData = useSelector(selectTaxResidencyAdditionalInformation);
  const initialValues = useMemo(
    () => getInitialValues(formData as TTaxResidencyAdditionalInformation),
    []
  );

  const form = useForm<TTaxResidencyAdditionalInformation>({
    resolver: yupResolver(
      validationSchema(beneficiaryOwners)
    ) as unknown as Resolver<TTaxResidencyAdditionalInformation>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: initialValues,
  });

  return form;
};
